import React from "react"
import Portfolio from "../images/portfolioimg.png"
import Workforce from "../images/Workforce Africa.png"
import AfriMLS from "../images/AfriMLS.png"
import JujaEats from "../images/juja-eats.png"
import NaiSausa from "../images/NaiSausa.png"
import Silabu from "../images/silabu.png"

import { AnimationOnScroll } from 'react-animation-on-scroll';
import AOS from "aos"
import 'aos/dist/aos.css';
AOS.init();


export default function ProjectsPage(){
    return(

        <section className="projects-sec text-gray-400 body-font" id="projects">
            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-col">
                    <div className="h-1 bg-gray-800 rounded overflow-hidden">
                        <div className="w-24 h-full bg-purple-500"></div>
                    </div>
                    <div className="flex flex-wrap sm:flex-row flex-col py-6 mb-12">
                        <h1 data-aos="zoom-in-up" className="sm:w-2/5 font-medium title-font text-3xl mb-2 sm:mb-0 projects-head text-purple-600">A snippet of some of my Projects! <br></br><a target="_blank" href="https://github.com/WalobwaD"><i className="fa-brands fa-github text-gray-700 pt-2 text-5xl"></i></a></h1>
                        <p data-aos="zoom-in" className="pro-text sm:w-3/5 leading-relaxed sm:pl-10 pl-0 font-light">A showcase of some of my Projects I designed from scratch. Both self initiated and tutorial based. For more projects, you can visit my <a target="_blank" href="https://github.com/WalobwaD">Github</a> account where I showcase all my latest projects. </p>
                    </div>
                </div>
                <AnimationOnScroll animateIn="animate__fadeInLeftBig" duration={0.2}>
                <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4">

                    <div className="proj p-4 md:w-1/3 sm:mb-0 mb-6">
                        <div className="rounded-lg h-64 overflow-hidden">
                        <img alt="content" className="object-cover object-center h-full w-full " src={Portfolio}></img>
                        </div>
                        <h2 className="text-xl font-medium title-font text-purple-600 mt-5">MY PORTFOLIO</h2>
                        <p className="pro-text text-base leading-relaxed mt-2">Self intitiated Project Powered by React to showcase my profile and personal projects/skills. </p>
                        <a className="text-purple-400 inline-flex items-center mt-3" target="_blank" href="https://github.com/WalobwaD">View Live
                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                        </a>
                    </div>
                    <div className="proj p-4 md:w-1/3 sm:mb-0 mb-6">
                        <div class="rounded-lg h-64 overflow-hidden">
                            <img alt="content" class="object-cover object-center h-full w-full" src={AfriMLS}></img>
                        </div>
                        <h2 class="text-xl font-medium title-font text-purple-600 mt-5">AfriMLS - Land Management System</h2>
                        <p class="pro-text text-base leading-relaxed mt-2">
                            AfriMLS is a Land Management System that allows users to register their land and give a marketing opportunity to real estate agents to sell the land.
                            Powered by PHP/Laravel and VueJS.
                            <br></br>

                        </p>
                            <a class="text-purple-400 inline-flex items-center mt-3" target="_blank" href="http://164.92.144.9/">View Live
                                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </a>
                    </div>
                    <div className="proj p-4 md:w-1/3 sm:mb-0 mb-6">
                        <div class="rounded-lg h-64 overflow-hidden">
                            <img alt="content" class="object-cover object-center h-full w-full" src={Workforce}></img>
                        </div>
                        <h2 class="text-xl font-medium title-font text-purple-600 mt-5">WorkForce Africa</h2>
                        <p class="pro-text text-base leading-relaxed mt-2">
                            WorkForce Africa is a job searching platform that allows users to explore various opportunities and find their dream jobs.<br></br>
                            Implemented OAuth2.0 for authentication and authorization. Powered By React/NextJS and Firebase <br></br>
                        </p>
                            <a class="text-purple-400 inline-flex items-center mt-3" target="_blank" href="https://workforce-africa.vercel.app/">View Live
                                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </a>
                    </div>
                    <div className="proj p-4 md:w-1/3 sm:mb-0 mb-6">
                        <div class="rounded-lg h-64 overflow-hidden">
                            <img alt="content" class="object-cover object-center h-full w-full" src={Silabu}></img>
                        </div>
                        <h2 class="text-xl font-medium title-font text-purple-600 mt-5">Silabu SMS</h2>
                        <p class="pro-text text-base leading-relaxed mt-2">
                            Silabu is a Student Management System that allows students to manage various aspects of their school life. <br></br>
                            Tech Stack used, React, Node, TypeScript, MongoDB/Mongoose, ExpressJS.
                        </p>
                            <a class="text-purple-400 inline-flex items-center mt-3" target="_blank" href="https://student-management-system-xi.vercel.app/">View Live
                                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </a>
                    </div>
                    <div className="proj p-4 md:w-1/3 sm:mb-0 mb-6">
                        <div class="rounded-lg h-64 overflow-hidden">
                            <img alt="content" class="object-cover object-center h-full w-full" src={NaiSausa}/>
                        </div>
                        <h2 class="text-xl font-medium title-font text-purple-600 mt-5">Nairobi Sausages</h2>
                        <p class="pro-text text-base leading-relaxed mt-2">
                        Nairobi Sausage's UI for the Login, Sell and Dashboard page, 
                        pig farmers should be able to login and upload details of their animals.
                         They need to purchase feeds from Nairobi Sausages, 
                         and eventually sell the full grown pigs to them. 
                         The price will vary according to the age and weight of the pigs. Powered by NuxtJS/VueJS

                        </p>
                            <a class="text-purple-400 inline-flex items-center mt-3" target="_blank" href="https://nairobisausages-dan.vercel.app/">View Live
                                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                                </svg>
                            </a>
                    </div>
                    <div className="proj p-4 md:w-1/3 sm:mb-0 mb-6">
                        <div className="rounded-lg h-64 overflow-hidden">
                        <img alt="content" className="object-cover object-center h-full w-full" src={JujaEats}></img>
                        </div>
                        <h2 className="text-xl font-medium title-font text-purple-600 mt-5">Juja Eats</h2>
                        <p className="pro-text text-base leading-relaxed mt-2">
                            Juja Eats is a food delivery platform that allows users to order food from their favorite restaurants and have it delivered to their doorsteps.<br></br>

                        </p>
                        <a className="text-purple-400 inline-flex items-center mt-3" target="_blank" href="https://juja-eats.netlify.app/">View Live
                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                        </a>
                    </div>
                </div>
                </AnimationOnScroll>
            </div>
        </section>
    )
}